export default __webpack_public_path__ + "static/freshdesk-68a7149896458ba757c0a3e3ec56bcae.svg";